import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
    user:null,
    count: 1,
    title: null
};

const mutations = {
    set_user(state,user){
        state.user = user;
    },
    set_title(state,title){
        state.title = title;
        localStorage.setItem('title', state.title);
    },
    increment(state){
        state.count++;
        localStorage.setItem('count', state.count);
    }
};

const getters = {};

export default new Vuex.Store({
    state,
    getters,
    mutations,
});